module.exports = __webpack_public_path__ + "media/images/icons/cross-211cc283512f2bb03aeb159d473a66fa.svg";